import { ClariahLink } from "components/ClariahLink";
import styles from "./SearchResultLive.module.css";

export const SearchResultLive = ({ href, title, type }) => (
  <ClariahLink className={styles.item} href={href || ""} type={type}>
    {title}
  </ClariahLink>
);
